import './target-csr.ajscss';

import { CsrFilter } from '@agent/core/contact/transfer/popup/popup-transfer.component';
import { hasChange, someHasChange } from '@commons/util/helper/helper';
import { copy, IChangesObject, IComponentController, IComponentOptions } from 'angular';
import { BehaviorSubject, debounceTime } from 'rxjs';

import { Group, Skill, Team } from '@contact/upgrade';

import templateUrl from './target-csr.html';

const MODULE_NAME = 'transferTargetCsr';

class TransferTargetCsrCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public eventUpdateCandidateCsr: Function;
  public eventTargetChange: Function;
  public skills: Skill[];
  public teams: Team[];
  public groups: Group[];
  public csrs: any[];
  public isMaxCsrListReach: boolean = false;
  public notifyOnInput: boolean = false;
  // internal properties
  public originalTeams: Team[];
  public originalGroups: Group[];
  public selectedSkills: Skill[];
  public selectedTeam: Team;
  public selectedGroup: Group;
  public selectedCsr: any;
  private lastfilter: CsrFilter;

  private readonly _agentChosen$ = new BehaviorSubject<string>('');
  readonly agentChosen$ = this._agentChosen$.asObservable();

  constructor() {
    this.skills = [];
    this.teams = [];
    this.originalTeams = [];
    this.groups = [];
    this.originalGroups = [];
    this.csrs = [];
    this.lastfilter = {};
    this.selectedSkills = [];
  }

  $onInit(): void {
    this._agentChosen$.pipe(debounceTime(500)).subscribe(csrPrefix => this.updateCandicateCsr(csrPrefix));
  }

  $onChanges(changesObj: { [property: string]: IChangesObject }) {
    // skills changed
    if (hasChange(changesObj['skills'])) {
      this.skills = copy(changesObj['skills'].currentValue);
    }
    // teams changed
    if (hasChange(changesObj['teams'])) {
      this.teams = copy(changesObj['teams'].currentValue);
      this.originalTeams = copy(changesObj['teams'].currentValue);
    }
    // groups changes
    if (hasChange(changesObj['groups'])) {
      this.groups = copy(changesObj['groups'].currentValue);
      this.originalGroups = copy(changesObj['groups'].currentValue);
    }
    // some in skills, teams or groups changed
    if (someHasChange(changesObj, 'skills', 'teams', 'groups')) {
      this.updateCandicateCsr();
    }
    // csr changed
    if (hasChange(changesObj['csrs'])) {
      this.csrs = copy(changesObj['csrs'].currentValue);
    }
  }

  $OnDestroy() {
    this._agentChosen$.complete();
  }

  onCsrInputChanged(): void {
    let input: HTMLInputElement = document.getElementById('agentSelection') as HTMLInputElement;
    let csrPrefix = '';
    if (input) csrPrefix = input.value || '';
    if (this.notifyOnInput) {
      this._agentChosen$.next(csrPrefix);
    }
  }

  updateCandicateCsr(csrPrefix: string = ''): void {
    let teamId = this.selectedTeam ? this.selectedTeam.id : null;
    let groupId: string | null = this.selectedGroup ? this.selectedGroup.id : null;
    let skillIds = this.selectedSkills.map(skill => skill.id);
    let filter: any = {
      teamId,
      groupId,
      skillIds,
      csrPrefix,
    };
    if (this.lastfilter !== filter) {
      this.lastfilter = filter;
      this.eventUpdateCandidateCsr({ $event: filter });
    }
  }

  onCsrTeamChange(): void {
    let input: HTMLInputElement = document.getElementById('popupCsrTeamSelection') as HTMLInputElement;
    let teamVal = '';
    if (input) teamVal = input.value || '';
    this.teams = this.originalTeams.filter(_team => _team.name.indexOf(teamVal) >= 0);
  }

  onCsrGroupChange(): void {
    let input: HTMLInputElement = document.getElementById('popupCsrGroupSelection') as HTMLInputElement;
    let groupVal = '';
    if (input) groupVal = input.value || '';
    this.groups = this.originalGroups.filter(_group => _group.name.indexOf(groupVal) >= 0);
  }

  onTargetChange(): void {
    this.eventTargetChange({ $event: { target: this.selectedCsr } });
  }
}

export class TransferTargetCsr implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    skills: '<',
    teams: '<',
    groups: '<',
    csrs: '<',
    notifyOnInput: '<',
    isMaxCsrListReach: '<',
    eventUpdateCandidateCsr: '&',
    eventTargetChange: '&',
  };
  controller = [TransferTargetCsrCtrl];
}

export default MODULE_NAME;
